"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pumaImage = void 0;
exports.pumaImage = ['imageService', function (imageService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'modules/images/directives/pumaimage.tpl.html',
            scope: {
                image: '='
            },
            link: function (scope, element, attrs) {
                scope.$watch('image', async () => {
                    if (!scope.image) {
                        return;
                    }
                    const imgElement = element[0];
                    URL.revokeObjectURL(imgElement.src); // Unload the previous image blob, if any
                    await imageService.SetImagePreviewUrl(scope.image.id, imgElement);
                });
            }
        };
    }];
